import { jsx } from 'react/jsx-runtime';
import { Icon } from '../Icon/Icon.js';

const getIconElement = (iconProps) => {
    if (!iconProps.icon) {
        return null;
    }
    if (typeof iconProps.icon === "string") {
        return (jsx(Icon, { content: iconProps.icon, appearance: "inherit", width: 16, height: 16 }));
    }
    else {
        return iconProps.icon;
    }
};

export { getIconElement };
//# sourceMappingURL=Button.utils.js.map
